import { useEffect, useState } from "react";
import { BrowserRouter, HashRouter, useNavigate } from "react-router-dom";
import { loginSelector } from "../../redux/slices/loginSlice";
import AppRoute from '../../routes/AppRoute';
import Sidebar from "../../components/Sidebar";
import { useSelector } from "react-redux";

const Layout = () => {
  // const loginStatus = localStorage.getItem('auth_status');

  const loginStore = useSelector(loginSelector);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <BrowserRouter>
      <div className="flex bg-gray-100" style={{ background: "#D0DAE766", width: "100%", height: '100%' }}>
        {loginStore.status === "authenticated" ? (
          <div style={{ display: "flex", width: "100%", height: '100%' }}>
            <div style={{ width: isSidebarOpen ? "300px" : "104px", transition: "width 0.3s ease" }}>
              <Sidebar
                isOpen={isSidebarOpen}
                toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
              />

            </div>
            <div
              className="flex flex-col"
    style={{
      flex: 1,
      width: "100%",
      height: "100%",
      transition: "all 0.3s ease",
    }}
            >

              {loginStore.status === "authenticated" ? (
                <AppRoute />
              ) : (
                <div></div>
              )}
            </div>
          </div>
        ) : (
          <AppRoute />
        )}
      </div>
     </BrowserRouter>
  );
};

export default Layout;
